import request from '@/utils/request/index';

export interface BubbleStatusResult {
  /** 会话侧是否有未读 */
  convUnread?: boolean;
  /** 精选侧是否有未读 */
  squareUnread?: boolean;
  /** 有未读粉丝会话的 bot ID 列表 */
  unreadBotIds?: string[];
  /** 有未读精选互动的 bot ID 列表 */
  squareUnreadBotIds?: string[];
  [property: string]: any;
}

export interface BubbleReadRequest {
  botId: string;
  [property: string]: any;
}

/** 查询当前用户红点状态 GET /bubble/status */
export const feimaBubbleStatus = () =>
  request<BubbleStatusResult>('/bubble/status', 'GET', {});

/** 会话侧标已读 POST /bubble/read/conversation */
export const feimaBubbleReadConversation = (data: BubbleReadRequest) =>
  request<null>('/bubble/read/conversation', 'POST', data);

/** 精选侧标已读 POST /bubble/read/square */
export const feimaBubbleReadSquare = (data: BubbleReadRequest) =>
  request<null>('/bubble/read/square', 'POST', data);
